import { useEffect } from "react";
import StockOpnameLegacy from "./StockOpnameLegacy";

function enhanceSelect(select) {
  if (!select || select.dataset.searchEnhanced === "1") return;
  select.dataset.searchEnhanced = "1";
  select.style.display = "none";

  const host = document.createElement("div");
  host.style.position = "relative";
  host.style.minWidth = "320px";
  host.dataset.opnameSearchHost = "1";

  const input = document.createElement("input");
  input.className = "field-input";
  input.placeholder = "Ketik SKU atau nama produk...";
  input.setAttribute("data-testid", "opname-product-search");

  const result = document.createElement("div");
  Object.assign(result.style, {position:"absolute",zIndex:"30",left:"0",right:"0",top:"100%",background:"#fff",border:"1px solid var(--border)",borderRadius:"8px",boxShadow:"0 8px 24px rgba(0,0,0,.12)",maxHeight:"300px",overflowY:"auto",display:"none"});

  const render = () => {
    const q = input.value.trim().toLowerCase();
    const options = [...select.options].filter(o => o.value && (!q || o.text.toLowerCase().includes(q))).slice(0, 10);
    result.innerHTML = "";
    if (!options.length) {
      const empty = document.createElement("div"); empty.className = "hint"; empty.style.padding = "10px"; empty.textContent = "Produk tidak ditemukan."; result.appendChild(empty);
    } else options.forEach(o => {
      const b = document.createElement("button"); b.type = "button"; b.className = "btn-ghost";
      Object.assign(b.style,{display:"block",width:"100%",textAlign:"left",borderRadius:"0",padding:"9px 12px"});
      b.textContent = o.text;
      b.onclick = () => { select.value = o.value; select.dispatchEvent(new Event("change", {bubbles:true})); input.value = o.text; result.style.display = "none"; };
      result.appendChild(b);
    });
    result.style.display = "block";
  };
  input.addEventListener("focus", render); input.addEventListener("input", render);
  document.addEventListener("click", e => { if (!host.contains(e.target)) result.style.display = "none"; });
  host.appendChild(input); host.appendChild(result); select.parentNode.insertBefore(host, select);
}

export default function StockOpname() {
  useEffect(() => {
    const run = () => document.querySelectorAll('select[data-testid="opname-product-select"]').forEach(enhanceSelect);
    run(); const obs = new MutationObserver(run); obs.observe(document.body, {childList:true, subtree:true});
    return () => obs.disconnect();
  }, []);
  return <StockOpnameLegacy />;
}
